module.exports = __webpack_public_path__ + "static/img/17041B_2_3_R_20200428_fit.bb1558c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/17041B_2_3_R_20200428_fit.png
// module id = QU5A
// module chunks = 0